exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html,body,#root{height:100%;margin:0;font-family:Helvetica Neue,Helvetica,Arial,Sans-Serif}.App{height:100%;color:var(--text-primary);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;line-height:1.3}.App-content{-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto}.App-footer{-ms-flex-negative:0;flex-shrink:0}.App a{text-decoration:none}.App p{font-size:14px}", ""]);

// exports
